import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {CountriesActions} from '../store';
import {CountriesSelectors} from '../store/selectors';

@Injectable()
export class CountriesLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {
    return this.loadCountriesDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadCountriesDone(): Observable<boolean> {
    return this.store.pipe(
      select(CountriesSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(CountriesActions.ReadCountries());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
